import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SaleziyaniOtcyaBosko = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Салезіяни отця Боско</h1>
        <div className="text-justify hyphens-auto" id="section1">
          <div className="pt-3 pb-3">
            Салезіянське Згромадження було засноване у 1859 році святим Іваном Боско в Турині, у районі Вальдокко. Це стало кульмінацією його тривалого та глибокого апостольського досвіду серед бідної молоді міста. Завдяки дружбі з отцем Йосифом Кафассо, своїм земляком, отець Боско дізнався про важкі умови життя дітей і підлітків Турину, зокрема про драматичну реальність підліткових в’язниць.
            <br /> <br />
            Фундаментальна подія, що поклала початок салезіянському служінню, відбулася 8 грудня 1841 року — у день Непорочного Зачаття Пресвятої Богородиці. Саме тоді, у церкві Сан-Франческо д’Ассізі в Турині, отець Боско зустрів юнака Бартоломео Гареллі перед літургією. Ця зустріч і спільна молитва «Богородице Діво» стали початком його виховно-душпастирської діяльності, спрямованої на найбіднішу та найпотребуючу молодь.
            <br /> <br />
            18 грудня 1859 року отець Іван Боско разом зі своїми першими вихованцями, отцями та семінаристами-братами, заснував релігійне Згромадження на честь святого Франциска Сальського — задля слави Божої та спасіння душ.
            <br /> <br />
            Салезіяни отримали папський декрет визнання у 1864 році, а їхні статути були затверджені Святим Престолом у 1874 році. Від моменту заснування вони присвятили себе євангелізації, катехизації, навчанню та вихованню молоді — у школах, ораторіях, парафіях, сільськогосподарських і професійних навчальних центрах. Окрім того, вони активно розвивали апостолат доброї преси та місій. Перше прохання щодо місійної діяльності салезіян надійшло з Аргентини — для євангелізації Патагонії.
          </div>
        </div>
      </div >
    </>
  );
};

export default SaleziyaniOtcyaBosko;
